import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import classes from './footerNavigation.module.css';
import whatsApp from '../../../../assets/images/whatsapp.png';
import facebook from '../../../../assets/images/facebook.png';
import linkedIn from '../../../../assets/images/linkedin.png';
import youtube from '../../../../assets/images/youtube.png';
import snapChat from '../../../../assets/images/snapchat.png';
import instagram from '../../../../assets/images/instagram.png';
import twitter from '../../../../assets/images/twitter.png';
import tiktok from '../../../../assets/images/tiktok.png';

const FooterNavigation = (props) => {
    return (
        <div className={classes.BottomFooter}>
            <div className={classes.FooterNavigation}>
                <div className={classes.SocialMediaLinks}>
                    <h4>{parseInt(localStorage.getItem('language')) === 1 ? "FOLLOW US" : "تابعنا"}</h4>
                    <div className={classes.List}>
                        {/* {props.socialLinks?.map((link,i) =><a key={i} href={link.url} target='_blank'><img src={link.icon} alt={link.platform} /></a>)} */}
                        <a href='https://wa.me/962790899534' target='_blank'><img src={whatsApp} alt="whatsApp icon" /></a>
                        <a href='https://www.facebook.com/6yardjo/' target='_blank'><img src={facebook} alt="facebook icon" /></a>
                        <a href='https://www.linkedin.com/company/6yard/' target='_blank'><img src={linkedIn} alt="linkedIn icon" /></a>
                        <a href='https://www.youtube.com/channel/UCgkloVt4t9ViPz5heAu5gSQ?view_as=subscriber' target='_blank'><img src={youtube} alt="youtube icon" /></a>
                        <a href='https://www.snapchat.com/sixyardjo' target='_blank'><img src={snapChat} alt="snapChat icon" /></a>
                        <a href='https://www.instagram.com/6yardjo/' target='_blank'><img src={instagram} alt="instagram icon" /></a>
                        <a href='https://x.com/6yardjo' target='_blank'><img src={twitter} alt="twitter icon" /></a>
                        <a href='https://www.tiktok.com/6yardjo' target='_blank'><img src={tiktok} alt="tiktok icon" /></a>
                    </div>
                </div>
                <div className={classes.QuickLinks}>
                    <h4>{parseInt(localStorage.getItem('language')) === 1 ? "QUICK LINKS" : "روابط سريعة"}</h4>
                    <div className={classes.List}>
                        {/* {props.quickLinks?.map((link, i) => <NavLink key={i} to={link.url}>{link.title}</NavLink>)} */}
                        <NavLink to={'/'}>{parseInt(localStorage.getItem('language')) === 1 ? "HOME" : "الرئيسية"}</NavLink>
                        <NavLink to={'/contact-us'}>{parseInt(localStorage.getItem('language')) === 1 ? "CONTACT US" : "اتصل بنا"}</NavLink>
                        <NavLink to={'/about-us'}>{parseInt(localStorage.getItem('language')) === 1 ? "ABOUT US" : "من نحن"}</NavLink>
                        <NavLink to={'/privacy-policy'}>{parseInt(localStorage.getItem('language')) === 1 ? "PRIVACY POLICY" : "سياسة الخصوصية"}</NavLink>
                        <NavLink to={'/terms-and-conditions'}>{parseInt(localStorage.getItem('language')) === 1 ? "TERMS AND CONDITIONS" : "الشروط والأحكام"}</NavLink>
                    </div>
                </div>
                <div className={classes.ContactInfo}>
                    <h4>{parseInt(localStorage.getItem('language')) === 1 ? "CONTACT INFO" : "معلومات الاتصال"}</h4>
                    <div className={classes.List}>
                        <a href={`mailto:${props.contactInfo?.email}`} target='_blank'>{props.contactInfo?.email}</a>
                        <div>{props.contactInfo?.phone}</div>
                    </div>
                </div>
            </div>
            <div className={classes.CopyRight}>
                <div className={classes.CopyrightText}>
                    © {new Date().getFullYear()} {parseInt(localStorage.getItem('language')) === 1 ? "6 Yard. All rights reserved" : "6 يارد. جميع الحقوق محفوظة."}
                </div>
                <div className={classes.PoweredBy}>
                    Powered by <a href="https://arageeks.com" target="_blank" rel="noopener noreferrer">AraGeeks</a>
                </div>
            </div>
        </div>
    )
}
export default FooterNavigation;
